import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import "@fortawesome/fontawesome-free/css/all.css"; // Ensure you are using css-loader

Vue.use(Vuetify);

export default new Vuetify({
  // Your theme and icon settings from the old file are preserved here
  icons: {
    iconfont: "fa" || "md", // 'fa' for FontAwesome, 'md' for Material Design
  },
  theme: {
    themes: {
      light: {
        primary: "#0e74cc",
        error: "#FF5252",
        info: "#269ad1",
        success: "#4CAF50",
        warning: "#FFC107",
        titleIcon: "#0e74cc",
        hint: "#929292",
      },
    },
  },
});
